function loggedIn () {
    return localStorage.getItem('login') == 'true';
}
function randStar () {
    return Math.floor(Math.random() * 5) + 1;     
}
function randNum (n = 100) {
    return Math.floor(Math.random() * n) + 1;
}

export {loggedIn, randStar, randNum};